import * as React from "react";
import { db } from "../../firebase";
import { Form , Button , Header} from 'semantic-ui-react'


interface InterfaceProps {
  error?: any;
  history?: any;
  tagName?: string;
  onTagAdded?: any
}

interface InterfaceState {
  error?: any;
  tagName?: string;
}

export class TagAddForm extends React.Component<
  InterfaceProps,
  InterfaceState
> {
  private static INITIAL_STATE = {
    error: null,
    tagName: "",
  };

  private static propKey(propertyName: string, value: string): object {
    return { [propertyName]: value };
  }

  constructor(props: any) {
    super(props);
    this.state = { ...TagAddForm.INITIAL_STATE };
  }

  public onSubmit = (event: any) => {
    const { tagName }: any = this.state;
    const { onTagAdded }: any = this.props;

   db.doCreateTag(tagName)
      .then(() => {
        this.setState(() => ({ ...TagAddForm.INITIAL_STATE }));
        onTagAdded()
      })
      .catch(error => {
        this.setState(TagAddForm.propKey("error", error));
      }); 

    event.preventDefault();
  };

  public render() {
    const { tagName, error }: any = this.state;

    const isInvalid = tagName === "";

    return (
      <div>
        <Header as='h2'>Add new tags</Header>
        <Form onSubmit={event => this.onSubmit(event)}>
          <input
            value={tagName}
            onChange={event => this.setStateWithEvent(event, "tagName")}
            type="text"
            placeholder="Tag Name"
          />

          <Button style={{marginTop :"10px"}}disabled={isInvalid} type="submit" positive>
            Add Tag
          </Button>

          {error && <p>{error.message}</p>}
        </Form>
      </div> 

    );
  }

  private setStateWithEvent(event: any, columnType: string): void {
    this.setState(
      TagAddForm.propKey(columnType, (event.target as any).value)
    );
  }
}


// WEBPACK FOOTER //
// ./src/pills/tags/tagAddForm.tsx